import * as React  from "react";

const CaptureAlert = (props) => {
  return (
    <>
      {props.isCaptured && <div className="alert alert-success alert-dismissible" role="alert">
      <button type="button"
              className="close"
              data-dismiss="alert"
              aria-label="閉じる"><span aria-hidden="true">×</span></button>
        画像をキャプチャしました。患者情報編集画面より確認できます。
      </div>}
      {props.isCaptureFail && <div className="alert alert-danger alert-dismissible" role="alert">
        <button type="button"
              className="close"
              data-dismiss="alert"
              aria-label="閉じる"><span aria-hidden="true">×</span></button>
        画像のキャプチャに失敗しました。患者画像は10枚まで保存できます。
      </div>}
    </>
  )
}

export default CaptureAlert

